import React from "react";
import { Layout } from "antd";
import Logo from "../assets/UTI-logo@2x.png";

import "./Styles/Container.css"; // Import CSS file

const Container = (props) => {
  return (
    <Layout style={{ overflow: "hidden" }}>
      <header className="header-container">
        <a
          href="https://utirx.com"
          style={{ display: "flex", alignItems: "center", flex: "1" }}
        >
          <img
            src={Logo}
            alt="UTI Logo"
            style={{ height: "61px", marginLeft: "20px" }}
          />
        </a>
        <a
          href="https://www.utirx.com/about-us/"
          className="about-text"
          style={{
            fontSize: "20px",
            fontWeight: "bolder",
            color: "#000",
            textDecoration: "none",
            flex: "1",
            marginLeft: "-90px",
          }}
          rel="noopener noreferrer"
        >
          About UTIRX
        </a>
      </header>
      <Layout.Content>{props.children}</Layout.Content>
    </Layout>
  );
};

export default Container;
